<template>
  <div id="impressao-casamento"
       class="ImpressaoCasamento mt-3">
    <div class="row mb-3">
      <div class="col-10 m-0 p-0 pr-5">
        <label for="name-1"
               class="ImpressaoCasamento_label">
          Nome atual do cônjuge
        </label>
        <input id="name-1"
               v-model="nomeAtualConjuge_0"
               type="text"
               name="name-1"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
      <div class="col-2 m-0 p-0">
        <label for="cpf-1"
               class="ImpressaoCasamento_label">
          Número do CPF
        </label>
        <input id="cpf-1"
               v-model="impressao.registro.pessoas.at(0).cpf"
               v-mask="'999.999.999-99'"
               type="text"
               name="cpf-1"
               class="form-control form-control-sm"
               placeholder="NÃO CONSTA"
               @change="getDadosConjuges()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-10 m-0 p-0 pr-5">
        <label for="name-2"
               class="ImpressaoCasamento_label">
          Nome atual do cônjuge
        </label>
        <input id="name-2"
               v-model="nomeAtualConjuge_1"
               type="text"
               name="name-2"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
      <div class="col-2 m-0 p-0">
        <label for="cpf-2"
               class="ImpressaoCasamento_label">
          Número do CPF
        </label>
        <input id="cpf-2"
               v-model="impressao.registro.pessoas.at(1).cpf"
               v-mask="'999.999.999-99'"
               type="text"
               name="cpf-2"
               class="form-control form-control-sm"
               placeholder="NÃO CONSTA"
               @change="getDadosConjuges()">
      </div>
    </div>
    <div class="row justify-content-center mb-3">
      <div class="col-5 text-center m-0 p-0">
        <label for="matricula"
               class="ImpressaoCasamento_label">
          Matrícula
        </label>
        <input id="matricula"
               v-model="impressao.registro.matricula"
               v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
               type="text"
               disabled
               name="matricula"
               class="form-control form-control-sm text-center"
               @change="changeImpressao()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-8 m-0 p-0 pr-5">
        <label for="nome_conjuge_0"
               class="ImpressaoCasamento_label">
          1º Cônjuge
        </label>
        <input id="nome_conjuge_0"
               v-model="nomeAntigoConjuge_0"
               type="text"
               name="nome_conjuge_0"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
      <div class="col-4 d-inline-flex justify-content-between m-0 p-0">
        <div class="col-3 m-0 p-0">
          <label for="nascimento_dia_conjuge_0"
                 class="ImpressaoCasamento_label">
            Dia
          </label>
          <input id="nascimento_dia_conjuge_0"
                 v-model="impressao.registro.pessoas.at(0).nascimento_dia"
                 type="number"
                 min="0"
                 name="nascimento_dia_conjuge_0"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="nascimento_mes_conjuge_0"
                 class="ImpressaoCasamento_label">
            Mês
          </label>
          <input id="nascimento_mes_conjuge_0"
                 v-model="impressao.registro.pessoas.at(0).nascimento_mes"
                 type="number"
                 min="0"
                 name="nascimento_mes_conjuge_0"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="nascimento_ano_conjuge_0"
                 class="ImpressaoCasamento_label">
            Ano
          </label>
          <input id="nascimento_ano_conjuge_0"
                 v-model="impressao.registro.pessoas.at(0).nascimento_ano"
                 type="number"
                 min="0"
                 name="nascimento_ano_conjuge_0"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-3 m-0 p-0 pr-5">
        <label for="nacionalidade_conjuge_0"
               class="ImpressaoCasamento_label">
          Nacionalidade
        </label>
        <input id="nacionalidade_conjuge_0"
               :key="renderiza_tela"
               v-model="impressao.registro.pessoas.at(0).nacionalidade_conjuge_0"
               type="text"
               name="nacionalidade_conjuge_0"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
      <div class="col-9 d-inline-flex justify-content-between m-0 p-0">
        <div class="col-3 m-0 p-0 pr-5">
          <label for="estado_civil_conjuge_0"
                 class="ImpressaoCasamento_label">
            Estado Civil
          </label>
          <input id="estado_civil_conjuge_0"
                 v-model="impressao.registro.pessoas.at(0).estado_civil"
                 type="text"
                 name="estado_civil_conjuge_0"
                 class="form-control form-control-sm"
                 @change="changeImpressao()">
        </div>
        <div class="col-8 m-0 p-0 pr-5">
          <label for="municipio_nascimento_conjuge_0"
                 class="ImpressaoCasamento_label">
            Município da naturalidade
          </label>
          <input id="municipio_nascimento_conjuge_0"
                 v-model="impressao.registro.pessoas.at(0).naturalidade"
                 type="text"
                 name="municipio_nascimento_conjuge_0"
                 class="form-control form-control-sm"
                 placeholder="NÃO CONSTA"
                 @change="changeNaturalidade()">
        </div>
        <div class="col-1 m-0 p-0">
          <label for="uf_conjuge_0"
                 class="ImpressaoCasamento_label">
            UF
          </label>
          <input id="uf_conjuge_0"
                 v-model="impressao.registro.pessoas.at(0).uf"
                 type="text"
                 name="uf_conjuge_0"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeUf()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 m-0 p-0">
        <label for="genitores_conjuge_0"
               class="ImpressaoCasamento_label">
          Genitor(es)
        </label>
        <div id="genitores_conjuge_0"
             type="text"
             name="genitores_conjuge_0"
             contenteditable="true"
             class="editorHtml_genitores form-control form-control-sm"
             @blur="getHtml(true, 'genitores_conjuge_0')"
             v-html="impressao.registro.pessoas.at(0).genitores_conjuge_0" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 m-0 p-0">
        <label for="nome_atual_conjuge_0"
               class="ImpressaoCasamento_label">
          Nome que o passou a utilizar
        </label>
        <input id="nome_atual_conjuge_0"
               v-model="nomeNovoConjuge_0"
               type="text"
               name="nome_atual_conjuge_0"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-8 m-0 p-0 pr-5">
        <label for="nome_conjuge_1"
               class="ImpressaoCasamento_label">
          2º Cônjuge
        </label>
        <input id="nome_conjuge_1"
               v-model="nomeAntigoConjuge_1"
               type="text"
               name="nome_conjuge_1"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
      <div class="col-4 d-inline-flex justify-content-between m-0 p-0">
        <div class="col-3 m-0 p-0">
          <label for="nascimento_dia_conjuge_1"
                 class="ImpressaoCasamento_label">
            Dia
          </label>
          <input id="nascimento_dia_conjuge_1"
                 v-model="impressao.registro.pessoas.at(1).nascimento_dia"
                 type="number"
                 min="0"
                 name="nascimento_dia_conjuge_1"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="nascimento_mes_conjuge_1"
                 class="ImpressaoCasamento_label">
            Mês
          </label>
          <input id="nascimento_mes_conjuge_1"
                 v-model="impressao.registro.pessoas.at(1).nascimento_mes"
                 type="number"
                 min="0"
                 name="nascimento_mes_conjuge_1"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="nascimento_ano_conjuge_1"
                 class="ImpressaoCasamento_label">
            Ano
          </label>
          <input id="nascimento_ano_conjuge_1"
                 v-model="impressao.registro.pessoas.at(1).nascimento_ano"
                 type="number"
                 min="0"
                 name="nascimento_ano_conjuge_1"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-3 m-0 p-0 pr-5">
        <label for="nacionalidade_conjuge_1"
               class="ImpressaoCasamento_label">
          Nacionalidade
        </label>
        <input id="nacionalidade_conjuge_1"
               :key="renderiza_tela"
               v-model="impressao.registro.pessoas.at(1).nacionalidade_conjuge_1"
               type="text"
               name="nacionalidade_conjuge_1"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
      <div class="col-9 d-inline-flex justify-content-between m-0 p-0">
        <div class="col-3 m-0 p-0 pr-5">
          <label for="estado_civil_conjuge_1"
                 class="ImpressaoCasamento_label">
            Estado Civil
          </label>
          <input id="estado_civil_conjuge_1"
                 v-model="impressao.registro.pessoas.at(1).estado_civil"
                 type="text"
                 name="estado_civil_conjuge_1"
                 class="form-control form-control-sm"
                 @change="changeImpressao()">
        </div>
        <div class="col-8 m-0 p-0 pr-5">
          <label for="municipio_nascimento_conjuge_1"
                 class="ImpressaoCasamento_label">
            Município da naturalidade
          </label>
          <input id="municipio_nascimento_conjuge_1"
                 v-model="impressao.registro.pessoas.at(1).naturalidade"
                 type="text"
                 name="municipio_nascimento_conjuge_1"
                 class="form-control form-control-sm"
                 placeholder="NÃO CONSTA"
                 @change="changeNaturalidade()">
        </div>
        <div class="col-1 m-0 p-0">
          <label for="uf_conjuge_1"
                 class="ImpressaoCasamento_label">
            UF
          </label>
          <input id="uf_conjuge_1"
                 v-model="impressao.registro.pessoas.at(1).uf"
                 type="text"
                 name="uf_conjuge_1"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeUf()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 m-0 p-0">
        <label for="genitores_conjuge_1"
               class="ImpressaoCasamento_label">
          Genitor(es)
        </label>
        <div id="genitores_conjuge_1"
             type="text"
             name="genitores_conjuge_1"
             contenteditable="true"
             class="editorHtml_genitores form-control form-control-sm"
             @blur="getHtml(true, 'genitores_conjuge_1')"
             v-html="impressao.registro.pessoas.at(1).genitores_conjuge_1" />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 m-0 p-0">
        <label for="nome_atual_conjuge_1"
               class="ImpressaoCasamento_label">
          Nome que o passou a utilizar
        </label>
        <input id="nome_atual_conjuge_1"
               v-model="nomeNovoConjuge_1"
               type="text"
               name="nome_atual_conjuge_1"
               class="form-control form-control-sm"
               @change="getDadosConjuges()">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-8 m-0 p-0 pr-5">
        <label for="data_do_casamento"
               class="ImpressaoCasamento_label">
          Data da celebração do casamento ou, se for o caso de conversão da união estável, data do registro.
        </label>
        <input id="data_do_casamento"
               v-model="impressao.dados.datas.data_casamento_extenso"
               type="text"
               name="data_do_casamento"
               class="form-control form-control-sm"
               @change="changeImpressao()">
      </div>
      <div class="col-4 d-inline-flex justify-content-between m-0 p-0">
        <div class="col-3 m-0 p-0">
          <label for="data_do_casamento_dia"
                 class="ImpressaoCasamento_label">
            Dia
          </label>
          <input id="data_do_casamento_dia"
                 v-model="impressao.dados.datas.casamento_dia"
                 type="number"
                 min="0"
                 name="data_do_casamento_dia"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="data_do_casamento_mes"
                 class="ImpressaoCasamento_label">
            Mês
          </label>
          <input id="data_do_casamento_mes"
                 v-model="impressao.dados.datas.casamento_mes"
                 type="number"
                 min="0"
                 name="data_do_casamento_mes"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="data_do_casamento_ano"
                 class="ImpressaoCasamento_label">
            Ano
          </label>
          <input id="data_do_casamento_ano"
                 v-model="impressao.dados.datas.casamento_ano"
                 type="number"
                 min="0"
                 name="data_do_casamento_ano"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <label for="regime_bens"
             class="ImpressaoCasamento_label">
        Regime de bens
      </label>
      <textarea id="regime_bens"
                v-model="impressao.dados.regime"
                name="regime_bens"
                rows="3"
                class="w-100 form-control form-control-sm"
                @change="changeImpressao()" />
    </div>

    <div class="row mb-3">
      <div class="col-8 m-0 p-0 pr-5">
        <label for="data_do_registro"
               class="ImpressaoCasamento_label">
          Data de registro do casamento
        </label>
        <input id="data_do_registro"
               v-model="impressao.dados.datas.data_registro_extenso"
               type="text"
               name="data_do_registro"
               class="form-control form-control-sm"
               @change="changeImpressao()">
      </div>
      <div class="col-4 d-inline-flex justify-content-between m-0 p-0">
        <div class="col-3 m-0 p-0">
          <label for="data_do_registro_dia"
                 class="ImpressaoCasamento_label">
            Dia
          </label>
          <input id="data_do_registro_dia"
                 v-model="impressao.dados.datas.dia"
                 type="number"
                 min="0"
                 name="data_do_registro_dia"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="data_do_registro_mes"
                 class="ImpressaoCasamento_label">
            Mês
          </label>
          <input id="data_do_registro_mes"
                 v-model="impressao.dados.datas.mes"
                 type="number"
                 min="0"
                 name="data_do_registro_mes"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
        <div class="col-3 m-0 p-0">
          <label for="data_do_registro_ano"
                 class="ImpressaoCasamento_label">
            Ano
          </label>
          <input id="data_do_registro_ano"
                 v-model="impressao.dados.datas.ano"
                 type="number"
                 min="0"
                 name="data_do_registro_ano"
                 class="form-control form-control-sm"
                 placeholder="N/C"
                 @change="changeImpressao()">
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <label for="anotacoes-averbacoes"
             class="ImpressaoCasamento_label">
        Anotações / Averbações
      </label>
      <div id="averbacoes_anotacoes"
           name="averbacoes_anotacoes"
           class="editorHtml text-justify"
           contenteditable="true"
           @blur="getHtml(false, 'averbacoes_anotacoes')"
           v-html="impressao.averbacoes_anotacoes" />
    </div>
  </div>
</template>
<script>
  /* libraries */
  import moment from 'moment'

  /* filters */
  import { maskCPF, firstCapitalize } from '@/filters/filters'

  /* constants */
  import estados from  '@/constants/brazilianStates'
  import { UNIAO_ESTAVEL, CASAMENTO_RELIGIOSO, CASAMENTO_RELIGIOSO_EFEITO_CIVIL } from "@/constants/casamento/tipos"
  import { getDocumentLabel } from "@/constants/documentosPessoais"

  /* helpers */
  import DataExtensoHelper from "@/helpers/Datas/DataExtensoHelper"

  /* services */
  import NacionalidadesService from "@/services/NacionalidadesService"

  export default {
    name: 'ImpressaoCasamento',
    props: {
      propCasamento: { type: Object, default: null},
      propAverbacoes: { type: Array, default: () => ([])},
      propOrgaoEmissor: { type: Object, default: () => ({})}
    },
    data () {
      return {
        CASAMENTO_RELIGIOSO,
        UNIAO_ESTAVEL,
        CASAMENTO_RELIGIOSO_EFEITO_CIVIL,
        paises: [],
        impressao: {
          registro: {
            pessoas: [
              {
                nome: null,
                genitores: []
              },
              {
                nome: null,
                genitores: []
              }
            ]
          },
          dados: {
            datas: {}
          }
        },
        datas: {
          dia: null,
          mes: null,
          ano: null,
          extenso: null,
        },
        meses: {
          '01': 'janeiro',
          '02': 'fevereiro',
          '03': 'março',
          '04': 'abril',
          '05': 'maio',
          '06': 'junho',
          '07': 'julho',
          '08': 'agosto',
          '09': 'setembro',
          '10': 'outubro',
          '11': 'novembro',
          '12': 'dezembro',
        },
        renderiza_tela: 0,
        tempPrimeiroConjuge: null,
        tempSegundoConjuge: null
      }
    },
    computed: {
      nomeAtualConjuge_0: {
        get () {
          return this.impressao.registro.pessoas.at(0).nome || this.impressao.registro.pessoas.at(0).nome_antigo
        },
        set (value) {
          this.impressao.registro.pessoas.at(0).nome = value

          if (!this.impressao.dados.conjuges.at(0).nome_novo) {
            this.impressao.dados.conjuges.at(0).nome_novo = value
          }

          if (!this.impressao.registro.pessoas.at(0).nome_novo) {
            this.impressao.registro.pessoas.at(0).nome_novo = value
          }
        }
      },
      nomeAtualConjuge_1: {
        get () {
          return this.impressao.registro.pessoas.at(1).nome || this.impressao.registro.pessoas.at(1).nome_antigo
        },
        set (value) {
          this.impressao.registro.pessoas.at(1).nome = value

          if (!this.impressao.dados.conjuges.at(1).nome_novo) {
            this.impressao.dados.conjuges.at(1).nome_novo = value
          }

          if (!this.impressao.registro.pessoas.at(1).nome_novo) {
            this.impressao.registro.pessoas.at(1).nome_novo = value
          }
        }
      },
      nomeNovoConjuge_0: {
        get () {
          if (!this.tempPrimeiroConjuge) {
            this.tempPrimeiroConjuge = this.impressao.registro.pessoas.at(0).nome || this.impressao.registro.pessoas.at(0).nome_antigo
            return this.impressao.registro.pessoas.at(0).nome || this.impressao.registro.pessoas.at(0).nome_antigo
          } else {
            return this.tempPrimeiroConjuge
          }
        },
        set (value) {
          this.impressao.dados.conjuges.at(0).nome_novo = value
          this.impressao.registro.pessoas.at(0).nome_novo = value
          this.tempPrimeiroConjuge = value
        }
      },
      nomeNovoConjuge_1: {
        get () {
          if (!this.tempSegundoConjuge) {
            this.tempSegundoConjuge = this.impressao.registro.pessoas.at(1).nome || this.impressao.registro.pessoas.at(1).nome_antigo
            return this.impressao.registro.pessoas.at(1).nome || this.impressao.registro.pessoas.at(1).nome_antigo
          } else {
            return this.tempSegundoConjuge
          }
        },
        set (value) {
          this.impressao.dados.conjuges.at(1).nome_novo = value
          this.impressao.registro.pessoas.at(1).nome_novo = value
          this.tempSegundoConjuge = value
        }
      },
      nomeAntigoConjuge_0: {
        get () {
          return this.impressao.registro.pessoas.at(0).nome_antigo
        },
        set (value) {
          this.impressao.dados.conjuges.at(0).nome_antigo = value
          this.impressao.registro.pessoas.at(0).nome_antigo = value
        }
      },
      nomeAntigoConjuge_1: {
        get () {
          return this.impressao.registro.pessoas.at(1).nome_antigo
        },
        set (value) {
          this.impressao.dados.conjuges.at(1).nome_antigo = value
          this.impressao.registro.pessoas.at(1).nome_antigo = value
        }
      }
    },
    watch: {
      propAverbacoes () {
        this.init()
      }, 
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        if (this.propCasamento) this.impressao = {...this.impressao, ...this.propCasamento}

        try {
          await this.loadPaises()
          this.getDataCasamento()
          this.tratarRegimeBens()
          this.getTipoTermo()
          this.getAverbacoes()
          this.tratarAnotacao()
          this.tratarTextoConjuges()
          this.tratarNovosNomes()
          this.getDadosConjuges()
          this.tratarTextoConjugesTermo()
          this.tratarTextoCasamentoCivil()
          this.tratarTextoCasamentoReligioso()
          this.tratarTextoUniaoEstavel()
          this.tratarMudancaNomes()
          this.getDataProclamas()
          this.getNomeJornal()
          this.tratarNacionalidade()
          this.getGenitores()
          this.renderizaTela()
          this.changeImpressao()
          this.getNomeNovo()
          this.tratarNaturalidade()
          this.formatDefaultItens()
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        }
      },
      getDataCasamento () {
        const data = moment(this.impressao.registro.data_registro).format('YYYY-MM-DD').split('-')
        const data_casamento = !!this.impressao.data_casamento ? moment(this.impressao.data_casamento).format('YYYY-MM-DD') : null
        const data_casamento_dividida = moment(this.impressao.data_casamento).format('YYYY-MM-DD').split('-')
        const data_registro = !!this.impressao.registro.data_registro ? moment(this.impressao.registro.data_registro).format('YYYY-MM-DD') : null
        const data_publicacao = this.impressao.data_publicacao ? moment(this.impressao.data_publicacao).format('YYYY-MM-DD') : ''

        this.impressao.dados.datas = {
          ano: parseInt(data[0], 10),
          mes: parseInt(data[1], 10),
          dia: parseInt(data[2], 10),
          casamento_ano: parseInt(data_casamento_dividida[0], 10),
          casamento_mes: parseInt(data_casamento_dividida[1], 10),
          casamento_dia: parseInt(data_casamento_dividida[2], 10),
          extenso: data ? DataExtensoHelper.dataExtenso(data) : null,
          data_casamento_extenso: data_casamento ?  DataExtensoHelper.dataExtenso(data_casamento) : 'NÃO CONSTA',
          data_casamento: data_casamento ?  moment(data_casamento).format('DD/MM/YYYY') : null,
          hora_casamento_extenso: this.impressao.hora_casamento ? DataExtensoHelper.horaExtenso(this.impressao.hora_casamento) : null,
          data_registro: data_registro ? moment(data_registro).format('DD/MM/YYYY') : null,
          data_registro_extenso: data_registro ? DataExtensoHelper.dataExtenso(data_registro) : 'NÂO CONSTA',
          data_publicacao: data_publicacao ? moment(data_publicacao).format('DD/MM/YYYY') : ''
        }
      },
      getAverbacoes () {
        let averbacoes = ''
        this.impressao.averbacoes = ''
        this.impressao.averbacao_certidao = ''
        this.impressao.averbacao_livro = ''
        this.impressao.averbacao_transporte = ''

        // caso for tipo "Casamento Religioso com efeito civil"
        // colocamos um texto a mais na averbacao
        if (this.impressao.tipo_casamento == this.CASAMENTO_RELIGIOSO || this.impressao.tipo_casamento  == this.CASAMENTO_RELIGIOSO_EFEITO_CIVIL) {
          moment.locale('pt-br')
          this.impressao.averbacao_certidao = this.impressao.averbacao_certidao.trim()
          this.impressao.averbacao_certidao += `Casamento Religioso realizado em: <b>${ moment(this.impressao.data_casamento).format('DD [de] MMMM [de] YYYY') }</b><br>`
        }
        if (this.propAverbacoes && this.propAverbacoes.length) {
          if (!!averbacoes) averbacoes += '<br>'
          try {
            this.propAverbacoes.forEach((averbacao, i) => {
              const line = averbacao.texto_averbacao

              averbacoes += i === 0 ? line : '<br>' + line

              if (averbacao.averb_acrescida_certidao) this.impressao.averbacao_certidao += line + '<br>'
              if (averbacao.averb_impressa_livro) this.impressao.averbacoes +=  line + '<br>'
              if (averbacao.averb_impressa_transporte) this.impressao.averbacao_transporte += line + '<br>'
            })
          } catch (e) {
            console.error(e)
          }
        }

      },
      getDadosConjuges () {
        const conjuges = []

        this.impressao.registro.pessoas.forEach(pessoa => {
          const {nome, nome_antigo, nome_novo, cpf} = pessoa

          conjuges.push({
            ...pessoa,
            nome: nome || nome_antigo,
            nome_antigo: nome_antigo || '',
            nome_novo: nome_novo || '',
            cpf: cpf ? maskCPF(cpf) : '',
            estado_civil: pessoa.estado_civil ? this.tratarEstadoCivil(pessoa.estado_civil) : null
          })
        })

        this.impressao.dados.conjuges = conjuges

        this.impressao.dados.publicacao = this.impressao.publicacao

        this.changeImpressao()
      },
      getHtml (dados, campo) {
        const html = document.querySelector('#' + campo).innerHTML
        const indice = campo.slice(-1)
         
        if (indice === '0' || indice === '1') {
          this.impressao.registro.pessoas.at(indice)[campo] = html          
          this.changeImpressao()
          return
        }

        if (dados) this.impressao.dados[campo] = html
        else this.impressao[campo] = html
        this.changeImpressao()
      },
      getDataProclamas () {
        const {habilitacao} = this.impressao

        if (habilitacao && habilitacao.registro && habilitacao.registro.tarefas) {
          const tarefaProclamas = habilitacao.registro.tarefas.find((tarefa) => tarefa.acao === 'PUBLICAR_PROCLAMAS')

          if (tarefaProclamas) {
            const data_cumprimento = tarefaProclamas.data_cumprimento ? moment(tarefaProclamas.data_cumprimento).format('DD/MM/YYYY') : null

            this.impressao.dados.datas.data_publicacao = data_cumprimento
          } else {
            this.impressao.dados.datas.data_publicacao = habilitacao.data_publicacao
          }
        }
      },
      getTipoTermo () {
        const tipos = {
          'Casamento Civil': 'casamento_civil',
          'Casamento Religioso com efeito civil': 'casamento_religioso',
          'Religioso com efeito civil com Habilitação posterior': 'casamento_religioso',
          'Conversão de união estável em casamento': 'uniao_estavel',
          'Afixação de edital de outra serventia': 'outra_serventia',
          'Registro de Casamento à vista de Habilitação': 'a_vista_habilitacao',
          'Casamento Civil por diligência': 'casamento_civil_por_diligencia'
        }

        this.impressao.dados.tipo_termo = tipos[this.impressao.tipo_casamento]
      },
      changeImpressao () {
        this.$emit('changeImpressao', this.impressao)
      },
      tratarTextoConjuges () {
        let text = ''

        this.impressao.registro.pessoas.forEach((pessoa, index) => {
          if (index === 1) text += '<br><br>'

          text += `<b>${pessoa.nome_antigo}</b>`
          text += pessoa.data_nascimento ? pessoa.sexo === 'F' ? ', nascida' : ', nascido' : ''
          text += pessoa.data_nascimento ? ` no dia ${this.tratarDataNascimento(pessoa.data_nascimento, index)}` : ''
          text += pessoa.naturalidade && !pessoa.naturalidade_declarada ? `, natural de ${pessoa.naturalidade + (pessoa.uf != 'EX' ? ' - ' + pessoa.uf : '')}` : ''
          text += !pessoa.naturalidade && pessoa.naturalidade_declarada ? `, natural de ${pessoa.naturalidade_declarada}` : ''
          text += pessoa.naturalidade === 'Outro' && pessoa.naturalidade_declarada ? `, natural de ${pessoa.naturalidade_declarada} - ${pessoa.uf}` : ''
          text += pessoa.naturalidade !== 'Outro' && pessoa.naturalidade_declarada ? `, natural de ${pessoa.naturalidade} - ${pessoa.uf}` : ''
          text += pessoa.nacionalidade ? `, de nacionalidade ${pessoa.nacionalidade.nome_feminino}` : ''
          text += pessoa.genitores.length ? this.tratarGeneroFilho(pessoa.sexo) : ''

          if (pessoa.genitores.length) {
            pessoa.genitores.forEach((genitor, index) => {
              text += genitor.pessoa.nome ? `${ (index == 0 ? ' de ' : '') + genitor.pessoa.nome}` : ''
              text += genitor.pessoa.naturalidade && !genitor.pessoa.naturalidade_declarada ?  `, natural de ${genitor.pessoa.naturalidade + (genitor.pessoa.uf != 'EX' ? ' - ' + genitor.pessoa.uf : '')}` : ''
              text += !genitor.pessoa.naturalidade && genitor.pessoa.naturalidade_declarada ? `, natural de ${genitor.pessoa.naturalidade_declarada}` : ''
              text += genitor.pessoa.naturalidade && genitor.pessoa.naturalidade_declarada ? `, natural de ${genitor.pessoa.naturalidade != 'Outro' ? genitor.pessoa.naturalidade : genitor.pessoa.naturalidade_declarada}${genitor.pessoa.uf != 'EX' ? ' - ' + genitor.pessoa.uf : ''}` : ''
              text += pessoa.genitores.length > 1 && index == 0 ? ' e ' : '.'
            })

          }
        })

        this.impressao.dados.texto_conjuges = text.replaceAll('- EX', '')
      },
      tratarGeneroFilho (sexo) {
        if (sexo === 'F') return ', filha'
        else return ', filho'
      },
      tratarDataNascimento (data, index) {
        if (!data) return ''

        const nascimento = data.split('-')

        const ano = nascimento[0]
        const mes = nascimento[1]
        const dia = nascimento[2]

        if (index === 0 || index === 1) {
          this.impressao.registro.pessoas.at(index).nascimento_dia = dia
          this.impressao.registro.pessoas.at(index).nascimento_mes = mes
          this.impressao.registro.pessoas.at(index).nascimento_ano = ano
        }

        return `${dia} de ${this.meses[mes]} de ${ano}`
      },
      tratarNovosNomes () {
        let nomes = ''

        this.impressao.registro.pessoas.forEach(pessoa => {
          // nomes += pessoa.nome ? `<b>${pessoa.nome}</b><br>` : ''
          nomes += `<b>${pessoa.nome || pessoa.nome_antigo}</b><br>`
        })

        this.impressao.dados.nomes = nomes
      },
      tratarRegimeBens () {
        const regimesDeBens =  [
          { value: 'COMUNHAO_PARCIAL', text: "Comunhão Parcial de Bens" },
          { value: 'COMUNHAO_UNIVERSAL', text: "Comunhão Universal de Bens" },
          { value: 'PARTICIPACAO_FINAL_AQUESTOS', text: "Participação Final Aquestos" },
          { value: 'SEPARACAO_BENS', text: "Separação de Bens" },
          { value: 'SEPARACAO_LEGAL_BENS', text: "Separação Legal de Bens" },
          { value: 'OUTROS', text: "Outros" },
          { value: 'IGNORADO', text: "Ignorado" }
        ]

        const regime = regimesDeBens.find(regime => regime.value === this.impressao.regime_bens)

        if (regime && regime.value == 'OUTROS' ) {
          // Caso seja do tipo outros não exibimos o tipo no inicio do texto
          !regime.text ? this.impressao.dados.regime = 'Não consta' : ''
          const { regime_bens_complemento } = this.impressao
          if (!!this.impressao.dados.regime) {
            this.impressao.dados.regime += regime_bens_complemento ? `${regime_bens_complemento}` : ''
          } else {
            this.impressao.dados.regime = regime_bens_complemento ? `${regime_bens_complemento}` : 'Não consta'
          }
        } else {
          this.impressao.dados.regime = regime ? regime.text : 'Não consta'
          const { regime_bens_complemento } = this.impressao
          this.impressao.dados.regime += regime_bens_complemento ? `, ${regime_bens_complemento}` : ''
        }

      },
      tratarAnotacao ()  {
        this.impressao.averbacoes_anotacoes = this.impressao.registro.complemento ? this.impressao.registro.complemento : ''
        if (!!this.impressao.averbacao_certidao) {
          if (!!this.impressao.averbacoes_anotacoes) {
            this.impressao.averbacoes_anotacoes += '<br>' + this.impressao.averbacao_certidao
          } else {
            this.impressao.averbacoes_anotacoes += this.impressao.averbacao_certidao
          }
        }

        if (this.impressao.tipo_casamento == UNIAO_ESTAVEL) {
          if (!this.impressao.averbacoes_anotacoes.match('Nada mais me cumpria')) {
            this.impressao.averbacoes_anotacoes += 'Nada mais cumpria informar.'
          }
        }
      },
      tratarEstadoCivil (estadoCivil) {
        if (['VIUVO', 'VIUVA'].indexOf(estadoCivil) !== -1) {
          estadoCivil = estadoCivil.replace('U', 'Ú')
          return estadoCivil.toLowerCase()
        } else {
          return estadoCivil.toLowerCase()
        }
      },
      tratarTextoConjugesTermo () {
        this.impressao.registro.pessoas.forEach((pessoa, index) => {
          const {sexo, ocupacao_declarada, naturalidade, naturalidade_declarada, uf, genitores, estado_civil, registrosAnteriores, nome, nome_antigo } = pessoa
          let text = ''

          if (this.impressao.dados.tipo_termo != 'uniao_estavel') {
            text += `<b>${sexo === 'F' ? 'Ela' : 'Ele'}</b>`
          } else {
            text += sexo === 'F' ? '<b>A convivente</b>' : '<b>O convivente</b>'
          }

          text += pessoa.nacionalidade ? `, de nacionalidade ${pessoa.nacionalidade.nome_feminino}` : ''
          text += ocupacao_declarada ? `, ${ocupacao_declarada.toLowerCase()}` : ''
          text += estado_civil ? `, ${this.tratarEstadoCivil(estado_civil)}` : ''
          text += registrosAnteriores && registrosAnteriores.length ? this.tratarCasamentoAnterior(registrosAnteriores, nome, nome_antigo) : ''
          text += this.tratarDocumento(pessoa.documentos)
          text += naturalidade !== 'Outro' ? `, natural de ${naturalidade}` : ''
          text += naturalidade === 'Outro' && naturalidade_declarada ? `, natural de ${naturalidade_declarada}` : ''
          text += naturalidade && !naturalidade_declarada && uf && uf != 'EX' ? ` - ${ uf }` : ''
          text += this.tratarRegistroNascimento(pessoa.registrosAnteriores)
          text += pessoa.data_nascimento ? this.tratarDataNascimentoTermo(sexo, pessoa.data_nascimento) : ''
          text += pessoa.endereco ? `, residente em ${this.tratarEndereco(pessoa.endereco)}` : ''
          text += this.tratarGenitores(sexo, genitores)

          this.impressao.dados.conjuges[index].texto_termo = text
        })
      },
      tratarDocumento (documentos, cpf = null) {
        if (!documentos || !documentos.length) return ''

        let text = ''

        const rg = documentos.find(documento => documento.tipo_documento === 'RG')
        const documento = documentos[0]

        if (rg) {
          const orgao_emissor = rg.codigo_orgao_emissor ? this.propOrgaoEmissor[rg.codigo_orgao_emissor].split('-') : null
          text += `, RG ${rg.numero}${ !!orgao_emissor ? ' - ' + orgao_emissor[0].replace(' ', '') : '' }${rg.uf_emissor ? '/' + rg.uf_emissor : '' }`
          text += rg.data_emissao ? `, data de emissão ${moment(rg.data_emissao).format('DD/MM/YYYY')}` : ''
        } else {
          text += `, ${getDocumentLabel(documento.tipo_documento)} ${documento.numero}`
          text += documento.data_emissao && documento.tipo_documento === 'CNH' ? `, data 1ª habilitação ${moment(documento.data_emissao).format('DD/MM/YYYY')}` : ''
          text += documento.data_emissao && documento.tipo_documento !== 'CNH' ? `, data de emissão ${moment(documento.data_emissao).format('DD/MM/YYYY')}` : ''
        }

        if (cpf) {
          text += rg || documento ? ' e ' : ', '
          text += `CPF ${maskCPF(cpf)}`
        }

        return text
      },
      tratarRegistroNascimento (registros) {
        const nascimento = registros.find(registro => registro.tipo_registro === 'N')

        if (nascimento) {
          let text = ''
          const {nome_cartorio, livro, folha, termo, uf} = nascimento

          text += nome_cartorio ? `${nome_cartorio} - ` : ''
          text += uf ? `${uf}` : ''
          text += livro ? `, Livro: ${livro}` : ''
          text += folha ? `, folha ${folha}` : ''
          text += termo ? `, termo ${termo}` : ''

          return text.length ? ` (registrado em ${text})` : ', '
        }

        return ''
      },
      tratarDataNascimentoTermo (sexo, data) {
        const nascimento = DataExtensoHelper.dataExtenso(data)
        let text = ''

        text += `, onde nasceu aos ${nascimento} `
        text += `(${moment(data).format('DD/MM/YYYY')})`

        return text
      },
      tratarEndereco (endereco) {
        let text = ''
        const {logradouro, numero, complemento, bairro, cidade, uf} = endereco

        text += logradouro ? `${logradouro}, ` : ''
        text += numero ? `${numero}, ` : ''
        text += complemento ? `${complemento}, ` : ''
        text += bairro ? `${bairro}, ` : ''
        text += cidade ? `${cidade} - ` : ''
        text += uf ? `${uf}` : ''

        return text
      },
      tratarGenitores (sexo, genitores) {
        if (!genitores || !genitores.length) return ''

        const last_index = genitores.length - 1
        let text = sexo === 'F' ? ', filha de ' : ', filho de '

        genitores.forEach((genitor, index) => {
          const {
            pessoa: {
              nome,
              naturalidade,
              naturalidade_declarada,
              uf,
              data_nascimento,
              endereco,
              falecido,
              sexo,
              documentos,
              ocupacao_declarada
            },
            localOcorrenciaFalecimento
          } = genitor

          if (index > 0 && index === last_index) text +=  ' e de '
          else if (index > 0 && index != last_index) text += ', '

          text += nome ? `${nome}` : ''

          if (falecido) {
            text += falecido && sexo === 'F' ? `, falecida` : ', falecido'
            if (localOcorrenciaFalecimento && localOcorrenciaFalecimento.endereco) {
              if (localOcorrenciaFalecimento.endereco.exterior) {
                text += ` (Local falecimento: Ex - ${ this.getPaisById(localOcorrenciaFalecimento.endereco.codigo_pais).nome }, ${ localOcorrenciaFalecimento.endereco.logradouro })`
              } else {

                text += ` (Local falecimento: ${ localOcorrenciaFalecimento.endereco.cidade } - ${ localOcorrenciaFalecimento.endereco.uf })`
              }
            }
          } else {
            text += this.tratarDocumento(documentos)

            // if (this.impressao.dados.tipo_termo === 'casamento_civil') {
            //   text += (naturalidade || naturalidade_declarada) && uf ? `, natural de ${naturalidade_declarada || naturalidade}${uf != 'EX' ? ' - ' + uf : ''}` : ''
            //   text += (naturalidade || naturalidade_declarada) && !uf ? `, natural de ${naturalidade}` : ''
            //   text += (!naturalidade && !naturalidade_declarada) && uf ? `, natural de ${uf}` : ''
            // }

            text += ocupacao_declarada ? `, ${ocupacao_declarada.toLowerCase()}` : ''
            text += data_nascimento ? sexo === 'F' ? ', nascida' : ', nascido' : ''
            text += data_nascimento ? ` no dia ${this.tratarDataNascimento(data_nascimento)}` : ''

            text += (naturalidade !== 'Outro') && uf ? `, natural de ${naturalidade}${uf !== 'EX' ? ' - ' + uf : ''}` : ''
            text += (naturalidade === 'Outro' && naturalidade_declarada) && uf ? `, natural de ${naturalidade_declarada}${uf !== 'EX' ? ' - ' + uf : ''}` : ''
            text += (naturalidade === 'Outro' && naturalidade_declarada) && !uf ? `, natural de ${naturalidade_declarada}` : ''
            text += (naturalidade !== 'Outro') && !uf && naturalidade ? `, natural de ${naturalidade}` : ''
            text += (!naturalidade && !naturalidade_declarada) && uf && uf !== 'EX' ? `, natural de ${uf}` : ''

            // text += naturalidade && uf ? `, natural de ${naturalidade + (uf != 'EX' ? ' - ' + uf : '')}` : ''
            // text += naturalidade && !uf ? `, natural de ${naturalidade}` : ''
            // text += !naturalidade && uf && uf != 'EX' ? `, natural de ${uf}` : ''

            text += endereco && endereco.cidade && endereco.uf ? `, residente em ${endereco.cidade} - ${endereco.uf}` : ''
            text += endereco && endereco.cidade && !endereco.uf ? `, residente em ${endereco.cidade}` : ''
            text += endereco && !endereco.cidade && endereco.uf ? `, residente em ${endereco.uf}` : ''
          }

          if (index === last_index) text +=  '.'
        })

        return text
      },
      tratarIdade (data) {
        if (!data) return ''

        const dataNascimento = moment(data)

        const diferenciaEmDias = moment().diff(dataNascimento, 'days')
        const diferenciaEmMeses = moment().diff(dataNascimento, 'months')
        const diferenciaEmAnos = moment().diff(dataNascimento, 'years')

        // fazemos todas as validações em dias, pois dependendo o mês e ano o resultado do moment() não sai preciso
        if (diferenciaEmDias < 30 || diferenciaEmMeses < 1) {
          return `, com ${diferenciaEmDias} ${diferenciaEmDias <= 1 ? 'dia' : 'dias'} de idade`
        }

        if (diferenciaEmMeses >= 1 && diferenciaEmMeses < 12) {
          return `, com ${diferenciaEmMeses} ${diferenciaEmMeses <= 1 ? 'mês' : 'meses'} de idade`
        }

        if (diferenciaEmAnos >= 1) {
          return `, com ${diferenciaEmAnos} ${diferenciaEmAnos <= 1 ? 'ano' : 'anos'} de idade`
        }

        return ''
      },
      tratarTextoCasamentoCivil () {
        let text = ''
        const data_casamento_extenso = this.impressao.dados.datas.data_casamento_extenso
        const data_casamento = this.impressao.dados.datas.data_casamento
        const cartorio = this.impressao.registro.livro.cartorio
        const partes = this.impressao.registro.partes

        text += `Em ${data_casamento_extenso} (${data_casamento}), `
        text += `nesta unidade de Serviço do Oficial de Registro Civil das pessoas naturais do `
        text += `${cartorio.nome}, Estado de ${this.tratarUF(cartorio.endereco.uf)}, `
        text += `ás ${this.impressao.dados.datas.hora_casamento_extenso}, `
        text += `perante o MM. Juiz de Casamentos ${firstCapitalize(this.impressao.juiz)}, `
        text += `comigo ${cartorio.nome_oficial}, Oficial, `
        text += partes && partes.length ? `e na presença das testemunhas: ${this.tratarTestemunhas(partes)}, ` : ''
        text += 'receberam-se em matrimonio, após as formalidades legais os contraentes:'

        this.impressao.dados.texto_casamento_civil = text
      },
      tratarTextoCasamentoReligioso () {
        let text_1 = ''
        let text_2 = ''

        const { dados, registro: {local, partes} , celebrante } = this.impressao
        const { data_registro_extenso, data_registro, data_casamento_extenso, data_casamento, hora_casamento_extenso } = dados.datas
        const cartorio = this.impressao.registro.livro.cartorio

        text_1 += `Em <b>${data_registro_extenso} (${data_registro})</b>, `
        text_1 += `nesta unidade de Serviço do Oficial de Registro Civil das pessoas naturais do `
        text_1 += `${cartorio.nome}, Estado de ${this.tratarUF(cartorio.endereco.uf)}, `
        text_1 += `procedo ao registro do casamento religioso de:`

        this.impressao.dados.texto_casamento_religioso_1 = text_1

        text_2 += `, celebrado em <b>${data_casamento_extenso} (${data_casamento})</b>`
        text_2 += hora_casamento_extenso ? `, às ${hora_casamento_extenso}` : ''
        text_2 += local && local.descricao ? `, na(o) ${local.descricao}` : ''
        text_2 += local && local.endereco && (local.endereco.logradouro || local.endereco.cidade) ? `, sito na(o) ${this.tratarEndereco(local.endereco)}` : ''
        text_2 += celebrante ? `, perante o celebrante ${firstCapitalize(celebrante)}` : ''
        text_2 += partes && partes.length ? `e na presença das testemunhas: ${this.tratarTestemunhas(partes)}.` :  '.'

        this.impressao.dados.texto_casamento_religioso_2 = text_2
      },
      tratarTextoUniaoEstavel () {
        let text_1 = ''
        let text_2 = ''

        const data_registro_extenso = this.impressao.dados.datas.data_registro_extenso
        const data_registro = this.impressao.dados.datas.data_registro

        const cartorio = this.impressao.registro.livro.cartorio

        text_1 += `Em <b>${data_registro_extenso} (${data_registro})</b>, `
        text_1 += `neste Ofício de Registro Civil das pessoas naturais do `
        text_1 += `${cartorio.nome}, Estado de ${this.tratarUF(cartorio.endereco.uf)}, `
        text_1 += `após as formalidades legais da prévia habilitação nos autos, `
        text_1 += `lavro o presente termo de conversão de união estável em casamento, `
        text_1 += `requerida pelos conviventes:`

        this.impressao.dados.texto_uniao_estavel_1 = text_1

        text_2 += `com fundamento no artigo 1.726 do Código Civil Brasileiro.`

        this.impressao.dados.texto_uniao_estavel_2 = text_2
      },
      tratarTestemunhas (testemunhas) {
        if (!testemunhas || !testemunhas.length) return ''

        const last_index = testemunhas.length - 1
        let text = ''

        testemunhas.forEach((testemunha, index) => {
          const {
            pessoa: {
              nome,
              data_nascimento,
              endereco,
              nacionalidade,
              estado_civil,
              ocupacao_declarada,
              documentos,
              cpf
            }
          } = testemunha

          if (index > 0 && index === last_index) text +=  ' e '
          else if (index > 0 && index != last_index) text += ', '

          text += nome ? `${nome}` : ''
          text += nacionalidade ? `, de nacionalidade ${nacionalidade.nome_feminino}` : ''
          text += estado_civil ? `, ${this.tratarEstadoCivil(estado_civil)}` : '',
          text += ocupacao_declarada ? `, ${ocupacao_declarada.toLowerCase()}` : ''
          text += this.tratarDocumento(documentos, cpf)
          text += this.tratarIdade(data_nascimento)
          text += data_nascimento ? `, nascido(a) em ${moment(data_nascimento).format('DD/MM/YYYY')}` : ''
          text += endereco && endereco.logradouro || endereco.cidade ? `, residente em ${this.tratarEndereco(endereco)}` : ''
        })

        return text
      },
      tratarMudancaNomes () {
        let text = ''

        this.impressao.registro.pessoas.forEach((pessoa, index) => {
          const { sexo, nome_antigo, nome } = pessoa


          if (index > 0) text += '<br><br>'

          if (this.impressao.dados.tipo_termo != 'uniao_estavel') {
            text += sexo === 'F' ? '<b>A contraente</b> ' : '<b>O contraente</b> '
          } else {
            text += sexo === 'F' ? '<b>A convivente</b> ' : '<b>O convivente</b> '
          }

          if (nome && (nome !== nome_antigo)) {
            text += `após o casamento, passará a se chamar ${nome}. `
          } else {
            text += `após o casamento, continuará a se chamar ${nome_antigo}. `
          }
        })

        this.impressao.dados.texto_mundanca_nomes = text
      },
      tratarUF (uf) {
        const estado = estados.find((estado) => estado.uf === uf)

        if (estado) {
          return estado.name
        } else {
          return uf
        }
      },
      tratarCasamentoAnterior (registrosAnteriores, nome, nome_antigo) {
        const tipos = ['C', 'CR', 'TC']

        const casamento = registrosAnteriores.find(registro => tipos.includes(registro.tipo_registro) && registro.registro_atual)

        if (!casamento) return ''

        const {conjuge, data_registro, nome_cartorio, data_dissolucao_casamento, livro, folha, termo, nome_registrado} = casamento

        // Verificamos se o conjuge é o registrado do registro anterior
        let nomeConjuge = conjuge ? conjuge.toUpperCase() : ''

        if (nomeConjuge && nome && conjuge === nome.toUpperCase()) {
          nomeConjuge = nome_registrado
        } else if (nomeConjuge && nome_antigo && conjuge === nome_antigo.toUpperCase()) {
          nomeConjuge = nome_registrado
        }

        let text = ''

        text += nomeConjuge ? ` (de ${nomeConjuge}, ` : ` (de NÃO INFORMADO`
        text += `com quem foi casado(a) aos ${data_registro ? moment(data_registro).format('DD/MM/YYYY') : 'NÃO INFORMADO'}, `
        text += `em ${nome_cartorio || 'NÃO INFORMADO'}, `
        text += data_dissolucao_casamento ? `e que o mesmo foi dissolvido pelo divórcio aos ` : ''
        text += data_dissolucao_casamento ? `${moment(data_dissolucao_casamento).format('DD/MM/YYYY')}, ` : ''
        text += `conforme a certidão de casamento lavrada no Livro ${livro || 'NÃO INFORMADO'}, `
        text += `fls ${folha || 'NÃO INFORMADO'}, sob o nª ${termo || 'NÃO INFORMADO'})`

        return text
      },
      async loadPaises () {
        try {
          loader({ active: true })
          this.paises = await NacionalidadesService.searchNacionalidadeByName("")
        } finally {
          loader({ active: false })
        }
      },
      getPaisById (codigo) {
        return this.paises.find(pais => pais.codigo == codigo)
      },
      getNomeJornal () {
        let publicacao = null

        if (this.impressao.publicacao === 'E_PROCLAMAS') {
          publicacao = `"e-Proclamas"`
        } else if (this.impressao.publicacao !== 'NAO_PUBLICAR') {
          publicacao = `"${this.impressao.publicacao}"`
        }

        this.impressao.dados.jornal = publicacao
      },
      tratarNacionalidade () {
        this.impressao.registro.pessoas.forEach((pessoa, index) => {
          const nacionalidade = pessoa.sexo === 'M' ? pessoa.nacionalidade.nome_masculino : pessoa.sexo === 'F' ? pessoa.nacionalidade.nome_feminino : pessoa.nacionalidade.nome_masculino
          this.impressao.registro.pessoas.at(index)[`nacionalidade_conjuge_${index}`] = nacionalidade
        })
      },
      getGenitores () {
        let genitores = ''

        this.impressao.registro.pessoas.forEach((pessoa, indice) => {
          genitores = pessoa.genitores.length ? pessoa.genitores.reduce((acc, genitor, i, array) => {
            return acc + '<b>' + genitor.pessoa.nome + '</b>' + `${(array.length - 1) === i ? '' : ';'}` + '<br>'
          },'') : 'Não consta'
          
          this.impressao.registro.pessoas.at(indice)[`genitores_conjuge_${indice}`] = genitores
        })
      },
      renderizaTela () {
        //renderiza_tela controla a atualização da interface, forçando a re-renderização dos componentes quando necessário.
        this.renderiza_tela++
      },
      getNomeNovo () {
        // Nome atual -> .nome 
        // Nome antigo -> .nome_antigo
        // Nome que passou a utilizar -> .nome_novo
        if (!!this.impressao.registro.pessoas[0]) {
          this.impressao.registro.pessoas[0].nome_novo =  !!this.impressao.registro.pessoas[0].nome ? this.impressao.registro.pessoas[0].nome : this.impressao.registro.pessoas[0].nome_antigo
          this.impressao.dados.conjuges[0].nome_novo =  this.impressao.registro.pessoas[0].nome_novo
        }
        if (!!this.impressao.registro.pessoas[1]) {
          this.impressao.registro.pessoas[1].nome_novo =  !!this.impressao.registro.pessoas[1].nome ? this.impressao.registro.pessoas[1].nome : this.impressao.registro.pessoas[1].nome_antigo
          this.impressao.dados.conjuges[1].nome_novo =  this.impressao.registro.pessoas[1].nome_novo
        }
      },

      changeNaturalidade () {
        // Atualizamos as informações dos dados também para utilizar na impressão e geração das certidões:
        if ( this.impressao.registro.pessoas[0] && this.impressao.registro.pessoas[0].naturalidade) {
          this.impressao.dados.conjuges[0].naturalidade = this.impressao.registro.pessoas[0].naturalidade
        }

        if ( this.impressao.registro.pessoas[1] && this.impressao.registro.pessoas[1].naturalidade) {
          this.impressao.dados.conjuges[1].naturalidade = this.impressao.registro.pessoas[1].naturalidade
        }

        this.changeImpressao()
      },

      tratarNaturalidade () {
        // Tratamos para utilizar a naturalidade declarada caso esteja como "Outros"
        if ( this.impressao.registro.pessoas[0] && this.impressao.registro.pessoas[0].naturalidade == "Outro" && !!this.impressao.registro.pessoas[0].naturalidade_declarada) {
          this.impressao.dados.conjuges[0].naturalidade = this.impressao.registro.pessoas[0].naturalidade_declarada
          this.impressao.registro.pessoas[0].naturalidade = this.impressao.registro.pessoas[0].naturalidade_declarada
        }

        if ( this.impressao.registro.pessoas[1] && this.impressao.registro.pessoas[1].naturalidade == "Outro" && !!this.impressao.registro.pessoas[1].naturalidade_declarada) {
          this.impressao.dados.conjuges[1].naturalidade = this.impressao.registro.pessoas[1].naturalidade_declarada
          this.impressao.registro.pessoas[1].naturalidade = this.impressao.registro.pessoas[1].naturalidade_declarada
        }

      },

      changeUf () {
        if ( this.impressao.registro.pessoas[0] && this.impressao.registro.pessoas[0].uf) {
          this.impressao.dados.conjuges[0].uf = this.impressao.registro.pessoas[0].uf
        }

        if ( this.impressao.registro.pessoas[1] && this.impressao.registro.pessoas[1].uf) {
          this.impressao.dados.conjuges[1].uf = this.impressao.registro.pessoas[1].uf
        }

        this.changeImpressao()

      },

      formatDefaultItens () {
        !this.impressao.registro.pessoas.at(0).nacionalidade_conjuge_0 ?  this.impressao.registro.pessoas.at(0).nacionalidade_conjuge_0 = 'NÃO CONSTA' : ''
        !this.impressao.registro.pessoas.at(1).nacionalidade_conjuge_1 ?  this.impressao.registro.pessoas.at(1).nacionalidade_conjuge_1 = 'NÃO CONSTA' : ''

        !this.impressao.registro.pessoas.at(0).estado_civil ? this.impressao.registro.pessoas.at(0).estado_civil = 'NÃO CONSTA' : ''
        !this.impressao.registro.pessoas.at(1).estado_civil ? this.impressao.registro.pessoas.at(1).estado_civil = 'NÃO CONSTA' : ''

        !this.impressao.registro.pessoas.at(0).naturalidade ? this.impressao.registro.pessoas.at(0).naturalidade = 'NÃO CONSTA' : ''
        !this.impressao.registro.pessoas.at(1).naturalidade ? this.impressao.registro.pessoas.at(1).naturalidade = 'NÃO CONSTA' : ''

        !this.impressao.registro.pessoas.at(0).uf ? this.impressao.registro.pessoas.at(0).uf = 'N/C' : ''
        !this.impressao.registro.pessoas.at(1).uf ? this.impressao.registro.pessoas.at(1).uf = 'N/C' : ''

        !this.impressao.dados.datas.data_casamento_extenso ? this.impressao.dados.datas.data_casamento_extenso = 'NÃO CONSTA' : ''




      }
    }
  }
</script>
<style lang="scss">
  .ImpressaoCasamento {
    &_label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
      line-height: 20px;
    }
  }

  .editorHtml {
    width: 100%;
    border: 1px solid #CCC;
    padding: 2px 10px;
    border-radius: 3px;
    background-color: #FFFFFF;

    &_genitores {
      padding: 10px;
      min-height: 70px;
      border-radius: 3px;
      background-color: #FFFFFF;
    }
  }

</style>
